import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'parseHeaders' })
export class ParseHeadersPipe implements PipeTransform {
  transform(value: any): string[] {
    if (!value) return [];
    const headers: any = { ...value };
    delete headers.Action;
    return Object.keys(headers).filter((key) => headers[key] !== '');
  }
}
